import SearchClientRepository, {
  SearchClientResponse,
} from "@domain/repositories/SearchClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { Filter } from "@domain/models/Filters";
import { userRoles } from "@domain/models/User";

type Input = {
  query: string;
  filters: Filter[];
  page: number;
};

type Output = Promise<SearchClientResponse>;

export class SearchTableAttendClientsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly searchClientRepository: SearchClientRepository
  ) {}

  async execute({ query, filters, page }: Input) {
    let textFilters = ``;
    const facetFilters = [];

    const user = this.userStore.user;

    if (user.role === userRoles.manager) {
      let stringFilter = "(";

      for (const index in user.operatorsIds) {
        const operator = user.users.operators.find((x) => x.id === user.operatorsIds[index]);

        if (operator) {
          if (parseInt(index) === 0) {
            stringFilter = stringFilter + `operatorName:"${operator.name}"`;
          } else {
            stringFilter = stringFilter + " OR " + `operatorName:"${operator.name}"`;
          }
        }
      }
      stringFilter = stringFilter + ")";

      textFilters = textFilters + stringFilter;
    }

    for (const filter of filters) {
      if (filter.type === "date") {
        if (filter.dateValue) {
          let stringFilter = textFilters.length > 0 ? " AND " : "";

          const selectedStart = filter.dateValue.selectedStart;
          const selectedEnd = filter.dateValue.selectedEnd;

          const startTime = new Date(
            Number(selectedStart.year),
            Number(selectedStart.month) - 1,
            Number(selectedStart.day),
            0,
            0,
            0
          ).getTime();

          // if selectedEnd not exists, will be set to the end of the day present in the select Start
          const endTime = selectedEnd.day
            ? new Date(
                Number(selectedEnd.year),
                Number(selectedEnd.month) - 1,
                Number(selectedEnd.day),
                23,
                59,
                59
              ).getTime()
            : new Date(
                Number(selectedStart.year),
                Number(selectedStart.month) - 1,
                Number(selectedStart.day),
                23,
                59,
                59
              ).getTime();

          stringFilter = stringFilter + `${filter.field}:${startTime} TO ${endTime}` + "";

          textFilters = textFilters + stringFilter;
        }
      } else {
        if (filter.values?.length > 0) {
          let stringFilter = textFilters.length > 0 ? " AND (" : "(";

          for (const index in filter.values) {
            if (parseInt(index) === 0) {
              stringFilter = stringFilter + `${filter.field}:"${filter.values[index].value}"`;
            } else {
              stringFilter =
                stringFilter + " OR " + `${filter.field}:"${filter.values[index].value}"`;
            }
          }
          stringFilter = stringFilter + ")";

          textFilters = textFilters + stringFilter;
        }
      }
    }

    return this.searchClientRepository.searchClients(query, textFilters, facetFilters, page);
  }
}
